import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CELL_SETS_CREATING } from 'redux/actionTypes/cellSets';
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import fetchWork from 'utils/work/fetchWork';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import loadCreatedCellSets from 'redux/actions/cellSets/loadCreatedCellSets';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var runCellSetsAnnotation = function runCellSetsAnnotation(experimentId, method, methodParams) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, error, updatingClustering, creatingCellSets, loading, body, timeout;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), error = _getCellSets.error, updatingClustering = _getCellSets.updatingClustering, creatingCellSets = _getCellSets.creatingCellSets, loading = _getCellSets.loading;
            if (!(creatingCellSets || loading && updatingClustering || error || experimentId === 'c26b1fc8-e207-4a45-90ae-51b730617bee')) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            body = {
              name: 'ScTypeAnnotate',
              // TODO: rename the task in the API and Rworker
              method: method,
              methodParams: methodParams
            };
            dispatch({
              type: CELL_SETS_CREATING
            });
            timeout = getTimeoutForWorkerTask(getState(), 'ClusterCells');
            _context.prev = 6;
            _context.next = 9;
            return fetchWork(experimentId, body, getState, dispatch, {
              timeout: timeout,
              broadcast: true
            });
          case 9:
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](6);
            handleError(_context.t0, endUserMessages.ERROR_CELL_SETS_ANNOTATION_FAILED);

            // To set the cell sets creation status back to false
            dispatch(loadCreatedCellSets(experimentId));
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default runCellSetsAnnotation;